/*
* Copyright © 2019 Insticator, Inc. All Rights Reserved.
*
* CONFIDENTIALITY NOTICE: THIS SOFTWARE CONTAINS CONFIDENTIAL INFORMATION OF
* INSTICATOR, INC. USE, DISCLOSURE OR REPRODUCTION IS PROHIBITED WITHOUT THE PRIOR
* EXPRESS WRITTEN PERMISSION OF INSTICATOR, INC.
*/

/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
import Component from 'inferno-component';
import Structure from 'components/shared/structure/structure_container';
// unique elements
import Frame from 'components/frames/frame_container';
import QuestionSet from 'components/content/shared/questionset/questionset';
import Story from 'components/content/shared/story/story_container';
import { preloadDataImages } from "utils/preloader";
// STYLES
// (css-in-js, imported as JS from external file, turned into CSS via library used in utils)
// import styles from 'components/content/quiz/quiz_styles';
// import { createStyles } from 'utils/styles';
// const sheet = createStyles(styles, {link:false});



/* ========== ~~~~~~~~~~ MIXED CONTENT : CHILD ~~~~~~~~~~ ========== */
// PRESENTATIONAL COMPONENT
// receives app state & actions as props from parent "_container" component
// this child component handles local state and uses props passed from parent to read/write application state when necessary
class MixedContent extends Component {
    constructor(props) {
        super(props);
        this.dataRequested = false;
    }

    componentWillReceiveProps(nextProps) {
        // FETCH CONTENT DATA
        if ((this.isContentActive() || this.isContentActive(nextProps)) && (this.props.dataFetchingPermitted || nextProps.dataFetchingPermitted)) {
            const cookieId = !!this.props.userId ? this.props.userId : nextProps.userId;
            this.fetchContentData(cookieId);
        }
        // Reset variable used to prevent multiple fetches on content deactivation. This will allow the content to re-fetch the data when the queue repeats.
        if (this.isContentActive() && !this.isContentActive(nextProps)) {
            this.dataRequested = false;
        }

        if (!this.isActiveContentWithFrames() && this.isActiveContentWithFrames(nextProps)) { // component will reactivate
            // this.setInitialFrameStatus();
        } else if (this.props.currentContentStatus['status'] === 'active' && !this.props.currentContentData.ready && nextProps.currentContentData.ready) {
            if (nextProps.currentContentData.data.length === 0) {
                this.props.deactivateContents([this.props.contentId]);
                this.props.handleRemainingContentInjection(nextProps)
            }
        // } else if (!this.props.currentContentData.ready && nextProps.currentContentData.ready) {
        //     if (nextProps.currentContentData.data.length !== 0) { this.setInitialFrameStatus(nextProps); }
        } else if (this.props.currentContentStatus['status'] !== 'active' && nextProps.currentContentStatus['status'] === 'active' && this.props.currentContentData.ready) {
            this.props.deactivateContents([this.props.contentId])
        }
    }

    fetchContentData(cookieId) {
        if (typeof window.getEmbedData !== "undefined" ||  this.dataRequested) { return null; } // DO NOT FETCH DATA IF A DATA FILE IS FOUND;
        const contentOrder = this.props.currentContentSettings.uniqueProps.framesOrder.toUpperCase();
        const numberOfQuestionsLimit = this.props.currentContentSettings.uniqueProps.numberOfQuestionsLimit;
        this.props.fetchContentsData(this.props.embedUUID, this.props.contentId, cookieId, contentOrder, numberOfQuestionsLimit, this.props.isPubPortalPreview);
        this.dataRequested = true;
    }

    createFrames() {
        // loop the returned data and create a frame component based off of it
        // store the frame in an array to be returned on render
        // create markup for questions and answers and pass that data to the frame component for display purposes (handled below)
        const contentId = this.props.contentId;
        const contentType = this.props.currentContentSettings.type;
        const showFrameForXSeconds = this.props.currentContentSettings.showFrameForXSeconds;
        const showResultForXSeconds = this.props.currentContentSettings.uniqueProps.showResultForXSeconds;
        const frameStatus = this.props.currentContentStatus.uniqueState.frameStatus;
        const abTestVersion = this.props.abTestVersion;
        const hasRewardsComponent = this.props.rewardsEnabled && this.props.rewardsPermitted;
        const advanceFrame = () => this.props.advanceFrame(this.props.contentId);
        const frames = [];
        this.props.currentContentData['data'].forEach((frameData, idx) => {
            switch (frameData.type) {
                case 'story':
                    const storyData = {
                        id: `${contentId}-${idx}`,
                        frame: idx,
                        frameData,
                        contentId,
                        frameStatus,
                        contentType,
                        hasRewardsComponent,
                        showFrameForXSeconds,
                        showResultForXSeconds,
                        advanceFrame
                    };
                    frames.push(<Frame id={frameData.story.id}
                                       type={frameData.story.type}
                                       frameIndex={idx}
                                       contentId={contentId}
                                       markup={<Story contentId={contentId} storyData={storyData}/>} />);
                    break;
                case 'quiz':
                case 'poll':
                default:
                    const questionSetData = {
                        id: `${contentId}-${idx}`,
                        frame: idx,
                        frameData,
                        contentId,
                        abTestVersion,
                        frameStatus,
                        contentType,
                        canSkipFrames: this.props.currentContentSettings.canSkipFrames,
                        hasRewardsComponent,
                        showFrameForXSeconds,
                        showResultForXSeconds,
                        advanceFrame
                    };
                    frames.push(<Frame id={frameData.question.id}
                                       type={frameData.question.type}
                                       frameIndex={idx}
                                       contentId={contentId}
                                       markup={QuestionSet(questionSetData)} />);
            }
        });
        return frames;
    }

    isContentActive(props = this.props) {
        return props.currentContentStatus['status'] === 'active'
    }

    isActiveContentWithFrames(props = this.props) {
        return this.isContentActive(props) && !this.isOutOfFrames();
    }

    isOutOfFrames(props=this.props) {
        if(props.currentContentStatus['totalFrameCount'] === null) { return false; }
        return props.currentContentStatus['frame'] >= props.currentContentStatus['totalFrameCount'];
    }

    render() {
        if (!this.isActiveContentWithFrames()) { return null; }
        return(
            <div className={`uniquecontent ${this.props.currentContentStatus['type']} `}>
                <Structure contentId={this.props.contentId} markup={this.createFrames()} />
            </div>
        );
    }
}



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default MixedContent;
